// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2z3ym","log":"ModalInventoryLogs_log__3rHzp","date":"ModalInventoryLogs_date__mts5a","userName":"ModalInventoryLogs_userName__3Kho6"};